export default "__VITE_ASSET__7acaf4e3__"